import { useSyncExternalStore } from 'react';
import { currentLang, onLangChange } from '../../i18n';
import type { Lang } from '../../i18n';

/** Re-renders the calling component on a UI language change. `currentLang()`
 *  returns a primitive, so no version-counter wrapper is needed here (unlike
 *  `useWorkspace`) — plain reference/value equality already works. */
export function useLang(): Lang {
  return useSyncExternalStore(onLangChange, currentLang);
}
